<template>
    <v-container fluid>
      <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'CategoryList'})"></luci-btn-icon>

      <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
        <span class="error-span luci-text white--text">{{ error }}</span>
      </v-alert>

      <div v-if="isLoading" class="loading">
        <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
      </div>

      <v-layout wrap v-if="!isLoading">
        <v-flex md6>
          <luci-form :config="formConfig" v-model="formData" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'CategoryList' })"></luci-form>
        </v-flex>
        <v-flex md6 :class="{ 'columnRightPadding': $vuetify.breakpoint.mdAndUp }">
          <h3 class="luci-subtitle">Translations</h3>
          <p class="luci-text">Click on the language to change the translation.</p>

          <template v-for="lang in languages">
            <button class="btn btn-lg lang-btn" :key="lang.id" v-if="lang.code !== 'en'" @click="translation(lang)">
              <div class="lang-btn-text font-weight-bold">{{ lang.name }}</div>
              <div class="lang-btn-text">{{ lang.code }}</div>
            </button>
          </template>
        </v-flex>
      </v-layout>

      <translation-modal v-if="selectedLanguage" :item="selectedLanguage" @close="translationModalOpened = false" :open="translationModalOpened"></translation-modal>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import variables from '../../helpers/variables'
import TranslationModal from './TranslationModal'

export default {
  components: {
    TranslationModal
  },
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions,
      selectedLanguage: { name: null },
      translationModalOpened: false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'category/update/isLoading',
      error: 'category/update/error',
      retrieved: 'category/update/retrieved',
      updated: 'category/update/updated',
      violations: 'category/update/violations',
      languages: 'category/update/languages'
    }),
    formData: {
      get () {
        return this.retrieved ? this.retrieved : { name: '', description: '' }
      },
      set (value) {
        this.updateRetrieved(value)
      }
    },
    formConfig () {
      return (
        {
          name: 'form-edit-category',
          title: 'Details',
          description: 'To update category please change the form below.',
          showButtonAsIcon: true,
          buttons: variables.formButtons,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter category name', clearable: true }
            },
            {
              order: 2,
              element: 'textarea',
              required: true,
              name: 'description',
              label: 'description',
              textareaConfig: { placeholder: 'Please enter category description', clearable: true }
            }
          ]
        }
      )
    }
  },
  created () {
    this.getLanguages()
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },
  methods: {
    ...mapActions({
      retrieve: 'category/update/retrieve',
      update: 'category/update/update',
      updateRetrieved: 'category/update/updateRetrieved',
      getLanguages: 'category/update/getLanguages',
      getTranslation: 'category/update/getTranslation'
    }),
    resetForm () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    submitForm () {
      this.update()
        .then(() => {
          if (!this.error) {
            this.$router.push({ name: 'CategoryList' })
          }
        })
    },
    translation (lang) {
      this.selectedLanguage = lang
      this.translationModalOpened = true
      this.getTranslation(lang.code)
    }
  }
}
</script>

<style lang="scss" scoped>
  .columnRightPadding {
    padding-left: 3rem;
  }
</style>
